 const PACKAGE_PRODUCTS = [
          {
            variantId: 49599949406537,
            switchId: 'switch2',
            enabled: $('#switch2').data('auto-enable')
          },
          {
            variantId: 54818909126985,
            switchId: 'switch4',
            enabled: $('#switch4').data('auto-enable')
          },
        ];

        $(document).on('click', '.cart-remove-button', function (e) {
          e.preventDefault();
          let $button = $(this);
          let itemKey = $button.data('variant-id'); // Assuming each button has a `data-item-key` attribute
          // Remove item from cart
          $.ajax({
            type: 'POST',
            url: '/cart/change.js',
            dataType: 'json',
            data: { id: itemKey, quantity: 0 },
            success: function (cart) {
              setTimeout(() => {
                checkPackageProtection(cart);
              }, 500);
              updateCartTotal(); // Update cart total
            },
          });
        });

        // Function to check package protection logic
        function checkPackageProtection(cart) {
  const packageProtection = document.querySelector('.package-protection');
  const packageProtection_cart = document.querySelector('.custom_cart-protection');
  const drawerFooter = document.querySelector('.drawer__footer');
  const cartFooter = document.querySelector('.cart__footer');
  const drawerContents = document.querySelector('.drawer__contents');
  const cartContents = document.querySelector('.cart__contents');

  if (cart.item_count === 1) {
    $.each(cart.items, function (i, v) {

      if (PACKAGE_PRODUCTS.some((p) => p.variantId === v.variant_id)) {

        removePackageProtection(v.variant_id);

        if (packageProtection) {
          packageProtection.style.display = 'none';

          if (packageProtection_cart) {
            packageProtection_cart.style.display = 'none';
          }
        }

        if (drawerFooter) {
          drawerFooter.style.display = 'none';

          if (cartFooter) {
            cartFooter.style.display = 'none';
          }
        }

        if (drawerContents) {
          drawerContents.style.display = 'none';

          if (cartContents) {
            cartContents.style.display = 'none';
          }
        }
      }

    });

  } else {

    $.each(cart.items, function (i, v) {

      if (
        PACKAGE_PRODUCTS.some((p) => p.variantId === v.variant_id) &&
        v.quantity > 1
      ) {

        $.ajax({
          type: 'POST',
          url: '/cart/change.js',
          dataType: 'json',
          data: {
            id: v.variant_id,
            quantity: 1,
          },
          success: function () {
            updateCartTotal();
          },
        });

      }

    });

  }
}

function addPackageProtection(variantId) {
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    dataType: 'json',
    data: {
      id: variantId,
      quantity: 1,
    },
    success: function () {
      updateCartTotal();
    },
  });
}

function removePackageProtection(variantId) {
  $.ajax({
    type: 'POST',
    url: '/cart/change.js',
    dataType: 'json',
    data: {
      id: variantId,
      quantity: 0,
    },
    success: function () {
      updateCartTotal();
    },
  });
}

        function updateCartTotal() {
          fetch('/cart.js')
            .then((response) => response.json())
            .then((cart) => {
              return fetch(`${window.location.pathname}?section_id=cart-drawer`)
                .then((response) => response.text())
                .then((responseText) => {
                  const html = new DOMParser().parseFromString(responseText, 'text/html');
                  const cartDrawer = document.querySelector('cart-drawer');
                  const newDrawerContent = html.querySelector('cart-drawer');

                  if (cartDrawer && newDrawerContent) {
                    cartDrawer.innerHTML = newDrawerContent.innerHTML;
                  }

                  // Update cart count bubble
                  $('.cart-count-bubble span[aria-hidden="true"]').text(cart.item_count);
                  $('.cart-count-bubble span.visually-hidden').text(
                    `${cart.item_count} item${cart.item_count !== 1 ? 's' : ''}`
                  );
                });
            })
            .catch((error) => console.error('Error updating cart drawer:', error));
        }

         PACKAGE_PRODUCTS.forEach(function (product) {
             $('.mct-cart-item-' + product.variantId).remove();
         });
         
        $('button.product-form__submit').click(function () {
  jQuery.getJSON('/cart.js', function (cart) {

    PACKAGE_PRODUCTS.forEach(function (product) {

      let found = false;

      $.each(cart.items, function (i, v) {
        if (v.variant_id == product.variantId) {
          found = true;
          return false;
        }
      });

      if (!found && product.enabled) {
        setTimeout(function () {
          addPackageProtection(product.variantId);
          $("#" + product.switchId).prop("checked", true);
        }, 1000);
      }

       });

      });
   });

        PACKAGE_PRODUCTS.forEach(function (product) {
          $(document).on('change', '#' + product.switchId, function (e) {
            e.preventDefault();

            if ($(this).is(':checked')) {
              addPackageProtection(product.variantId);
            } else {
              removePackageProtection(product.variantId);
            }
          });
        });